import nodeEl$ from '~src/messages/nodeEl$';
import useObservable from './useObservable';

export default function useNodeEl(id?: string) {
	return useObservable(nodeEl$(id));
}